import type { Canvas } from 'fabric';

const removeActiveItem = (canvas: Canvas): void => {
  const activeObjs = canvas.getActiveObjects();

  for (const activeObj of activeObjs) {
    if (!activeObj) continue;

    if (activeObj.pathLine) {
      // lines consist of multiple elements, we must manually remove each one
      for (const part of [
        activeObj.pathLine,
        activeObj.arrowHead,
        activeObj.pointStart,
        activeObj.pointEnd,
        activeObj.pointCurve,
      ]) {
        if (part) canvas.remove(part);
      }
    }

    // the item is about to be removed, so de-select it
    canvas.discardActiveObject();

    canvas.remove(activeObj);
  }
};

export default removeActiveItem;
